<template>
  <div v-clickOutside="close" class="px-15 md:pl-30 md:pr-5 mt-16 cursor-pointer relative" :class="{'z-9999': isTrialOver}">
    <div
      class="hover:bg-hover-book md:transition-color md:duration-300  text-app-color flex justify-between items-center px-20 py-8 rounded-8"
      :class="[ {'rounded-b-none': showDropdown}, classes ]"
      @click="showDropdown = !showDropdown"
    >
      <div class="truncate">
        <p class="truncate font-bold text-18 text-app-color leading-none mt-5">{{ title }}</p>
        <p class="text-app-color opacity-70 text-14">{{ user.email }}</p>
      </div>
      <i class="icon-keyboard-arrow-down text-app-color text-14 transition duration-300 " :class="{ 'transform -rotate-180': showDropdown }" />
    </div>
    <transition name="fade">
      <div v-if="showDropdown" class="w-full">
        <div @click.stop>
          <div
            class="hover:bg-selection rounded-b-8"
            :class="isPoseidonTheme ? 'shadow-card-poseidon bg-primary' : isDarkMode ? 'shadow-sharpDark bg-hover' : 'shadow-sharp bg-primary'"
            @click="selectOption"
          >
            <div class="text-app-color p-12 w-full">
              Switch to - <span class="font-bold">{{ titleSelect }}</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import localStorageService from '@/core/local-storage'

export default defineComponent({
  name: 'DropdownTeamsPersonal',

  setup () {
    const { state, getters, dispatch, commit } = useStore()
    const router = useRouter()

    const personal = 'Personal'

    const showDropdown = ref(false)

    const team = computed(() => state.team.team)
    const user = computed(() => state.profile.user)
    const isTeamAccount = computed(() => getters.isTeamAccount)
    const isPoseidonTheme = computed(() => state.settings.settings.theme === 'Poseidon')
    const isDraculaTheme = computed(() => state.settings.settings.theme === 'Dracula')
    const isDarkMode = computed(() => getters.isDarkMode)
    const isTrialOver = computed(() => getters.isTrialOver)

    const titleSelect = ref(isTeamAccount.value ? personal : team.value.name)
    const title = ref(isTeamAccount.value ? team.value.name : personal)
    const showBookOnboarding = computed(() => user.value.profile.showBookOnboarding)

    const classes = computed(() => {
      let c = ''

      if (showBookOnboarding.value) {
        if (isPoseidonTheme.value) {
          c = 'shadow-card-poseidon bg-white'
        } else {
          c = `bg-primary md:bg-book ${isDarkMode.value ? 'shadow-sharpDark' : 'shadow-sharp'}`
        }
      } else {
        c = 'bg-transparent'
      }

      return c
    })

    function selectOption () {
      commit('setProjects', [])
      commit('setTemplates', [])

      if (titleSelect.value === personal) {
        titleSelect.value = team.value.name
        title.value = personal
        commit('setTeamId', null)
        localStorageService.setItem('account-type', '')
        dispatch('getGlobalData').then(() => router.push({ name: 'Books' }))
      } else {
        titleSelect.value = personal
        title.value = team.value.name
        commit('setTeamId', team.value.id)
        localStorageService.setItem('account-type', team.value.link)
        dispatch('getGlobalData').then(() => router.push({ name: 'TeamBooks', params: { team: team.value.link } }))
      }

      close()
    }

    function close () {
      showDropdown.value = false
    }

    return {
      // refs
      showDropdown,
      // computed
      isPoseidonTheme,
      isDraculaTheme,
      isDarkMode,
      team,
      user,
      title,
      titleSelect,
      showBookOnboarding,
      classes,
      isTrialOver,
      // function
      selectOption,
      close
    }
  }
})
</script>
